import {request} from "./request";

export function getBagData(token) {
  return request({
    url: '/package/propList',
  },token)
}

export function useTool(id,token) {
  return request({
    url: '/package/useProp',
    data: {
      'propId': id
    }
  },token)
}
